import { Controller } from "@hotwired/stimulus"

// Live elapsed-time clock (m:ss) on an in-progress IngestionRun's Status line.
//
// The show page re-renders only on Turbo Stream broadcasts (per progress
// update), not every second, so the clock is driven client-side here. It's
// derived from an absolute start timestamp (startedAt, epoch ms), so it stays
// correct across broadcast re-renders that reconnect this controller.
//
// Wiring (see app/views/tools/ingestion_runs/_ingestion_run.html.erb):
//   <p data-controller="run-progress"
//      data-run-progress-started-at-value="<epoch-ms>">
//     ... <span data-run-progress-target="elapsed" class="ms-auto">0:00</span>
//   </p>
export default class extends Controller {
  static targets = ["elapsed"]
  static values = { startedAt: Number }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    if (!this.hasElapsedTarget || !this.startedAtValue) return

    const total = Math.max(0, Math.floor((Date.now() - this.startedAtValue) / 1000))
    const mins = Math.floor(total / 60)
    const secs = String(total % 60).padStart(2, "0")
    this.elapsedTarget.textContent = `${mins}:${secs}`
  }
}
